import SolutionFeaturesI18n from "@/components/landing/shared/SolutionFeaturesI18n";
import { Search, MessageCircle, GitCompare, ShoppingBag, ArrowRightLeft } from "lucide-react";
const EcommerceFeaturesSection = () => <SolutionFeaturesI18n translationPrefix="ecommerceSolution" icons={[Search, MessageCircle, GitCompare, ShoppingBag, ArrowRightLeft]} />;
export default EcommerceFeaturesSection;
